module.exports = new __parcel__URL__("favicon-temp-jsm.a82c490c.png").toString();